<template>
    <div class="absolute bottom-5 right-4 flex w-[176px] rounded border border-gray-40">

        <div  :class="['relationship-tool relative cursor-pointer px-2 py-1', { 'relationship-tool-split leading-3': !item.text }]" v-for="item in formattedZoom" :key="item.name" @click="item.action">
            <div class="th-tooltip " :data-tip="item.name">
                <span v-if="item.text" class="leading-6">{{ item.text }}</span>
                <PtIcon
                    v-else
                    :icon='item.icon'
                    class="th-btn-icon fill-grey-450 text-2xl"
                />
            </div>

        </div>

    </div>
</template>

<script setup lang="ts">
import { PtIcon } from 'patsnap-biz';
import '@patsnap-ui/icon/assets/solid/refresh.svg'
import '@patsnap-ui/icon/assets/solid/ZoomInBoard.svg'
import '@patsnap-ui/icon/assets/solid/ZoomOut.svg'
import '@patsnap-ui/icon/assets/solid/ZoomIn.svg'
import type { IFormattedZoom } from '@/types';
defineProps<{
    formattedZoom: IFormattedZoom[]
}>();

</script>
<style lang="scss">
.relationship-tool-split {
    &::after {
        content: "";
        position: absolute;
        top: 0.25rem;
        bottom: 0.25rem;
        right: 0;
        width: 0;
        border-right: 1px solid #ebecf0;
    }
}
</style>
